import { h } from 'preact';
import BaseComponent from '../BaseComponent';
import { update } from 'Emitter';
import { MEDIA } from 'StateEvents';
import './Mute.css';

export default class Mute extends BaseComponent {
  constructor() {
    super();
  }

  unMute() {
    update(MEDIA.VOLUME_CHANGE, 'unMute', 1);
  }

  render(props) {
    if(props.display && props.options.mute) {
      return <div class="mute-toggle clickable" onClick={ this.unMute.bind(this) }></div>
    }

    return null;
  }
}


// WEBPACK FOOTER //
// ./src/Display/Components/Mute/Mute.js